import React, { useEffect, useState } from 'react'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import correctionIcon from 'assets/icons/correction-icon.svg'
import errorPageMessages from 'constants/errorPageMessages' // Import error messages

import { useStyles } from '../../styles/material-styles/errorpageComponent'
import {
  ErrorPageComponentProps,
  ErrorType,
} from '../../ts/interfaces/ErrorPageComponent.interface'

const ErrorPageComponent: React.FC<ErrorPageComponentProps> = ({
  errorCode,
  title,
  description,
}) => {
  const [errorType, setErrorType] = useState<ErrorType | null>(null)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  useEffect(() => {
    // Determine the error type and message based on errorCode
    if (errorCode) {
      let determinedErrorType: ErrorType
      let determinedErrorMessage: string

      switch (errorCode) {
        case 'DEAL_RESTRICTED':
        case 'INVALID_DEAL':
          determinedErrorType = 'invalidDeal'
          determinedErrorMessage = errorPageMessages[errorCode]
          break

        case 'DEAL_FROZEN':
          determinedErrorType = 'restrictedDeal'
          determinedErrorMessage = errorPageMessages.DEAL_FROZEN
          break

        case 'AUTHENTICATION_FAILED':
        case 'ACCESS_DENIED':
          determinedErrorType = 'authentication'
          determinedErrorMessage = errorPageMessages[errorCode]
          break

        default:
          determinedErrorType = 'generalError'
          determinedErrorMessage = errorPageMessages.GENERAL_ERROR
      }

      setErrorType(determinedErrorType)
      setErrorMessage(determinedErrorMessage)
    } else {
      setErrorType('generalError')
      setErrorMessage(errorPageMessages.GENERAL_ERROR)
    }
  }, [errorCode])

  const { classes } = useStyles()

  return (
    <div className={classes.error}>
      {/* Conditionally render the correction icon for restricted or invalid deal errors */}
      {errorType === 'restrictedDeal' || errorType === 'invalidDeal' ? (
        <img className={classes.correctionIcon} src={correctionIcon} alt="Correction Icon" />
      ) : (
        <ErrorOutlineOutlinedIcon className={classes.icon} data-testid="ErrorOutlineOutlinedIcon" />
      )}
      <div className={classes.errorMessageText}>
        {title ?? 'Error'}: {description ?? errorMessage}
      </div>
    </div>
  )
}

export default ErrorPageComponent
